export default {
  brand: 'USFansLink',
  navSpreadsheet: 'Hoja de cálculo',
  navGuides: 'Guías',
  navReviews: 'Reseñas',
  navShipping: 'Envío',
  navSafety: 'Seguridad',
  navBlog: 'Blog',
  browseLabel: 'Explorar categorías',
  categoryTitle: 'Compra por categoría',
  categorySubtitle: 'Ve directo a la sección que necesitas en el sitio web principal.',
  visitMain: 'Visitar sitio principal',
  buyNow: 'Comprar ahora',
  usfansSpreadsheet: 'Hoja de cálculo USFans',
  language: 'Idioma',
  footerTagline: 'Tu centro de recursos independiente para guías de la hoja de cálculo USFans, investigación de productos, consejos de QC y envío.',
  footerResources: 'Recursos',
  footerLegal: 'Legal',
  about: 'Acerca de',
  editorialPolicy: 'Política editorial',
  contact: 'Contacto',
  privacyPolicy: 'Política de privacidad',
  terms: 'Términos',
  disclaimer: 'Aviso legal',
  disclaimerText: 'USFansLink.beauty es un recurso informativo independiente y no está afiliado ni respaldado por USFans, salvo que se indique explícitamente.',
  navHome: 'Inicio',
  navShoppingGuide: 'Guía de compras',
  tagResource: 'Recurso',
  tagReview: 'Reseña',
  tagLegit: 'Legalidad',
  tagShipping: 'Envío',
  tagWarehouse: 'Almacén',
  tagQc: 'QC',
  tagCoupon: 'Cupón',
  tagSeller: 'Vendedor',
  tagSafety: 'Seguridad',
  copyright: '© 2026 USFansLink.beauty. Todos los derechos reservados.',
  notFoundTitle: 'Artículo no encontrado',
  notFoundText: 'El artículo que buscas no existe o puede haber sido movido.',
};